import React, { useEffect, useState } from 'react';
import './App.css';

const phrases = [
  {
    main: 'Websites',
    sub: 'that convert',
    color: '#00e676' // green
  },
  {
    main: 'Games',
    sub: 'that amaze',
    color: '#40a9ff' // blue
  },
  {
    main: 'Blockchain Dapps',
    sub: 'that enable',
    color: '#b388ff' // purple
  },
  {
    main: 'Desktop Apps',
    sub: 'that perform',
    color: '#ffd54f' // yellow
  },
  {
    main: 'Mobile Apps',
    sub: 'that engage',
    color: '#ff5252' // red
  }
];

export default function HeroSwitcher() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % phrases.length);
    }, 2200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero-switcher">
      <span className="hero-switcher-main" style={{ color: phrases[index].color }}>
        {phrases[index].main}
      </span>
      <span className="hero-switcher-sub">{phrases[index].sub}</span>
    </div>
  );
}
